export const STUDENTS_INFO = 'STUDENTS_INFO';
export const STUDENTS_INFO_SUCCESS = 'STUDENTS_INFO_SUCCESS';
export const STUDENTS_INFO_FAIL = 'STUDENTS_INFO_FAIL';

export const REFRESH_STUDENTS_DATA = 'REFRESH_STUDENTS_DATA';

export const LOAD_NEXT_STUDENTS = 'LOAD_NEXT_STUDENTS';
export const LOAD_NEXT_STUDENTS_SUCCESS = 'LOAD_NEXT_STUDENTS_SUCCESS';
